import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.CustomerHomePage.components.RecentOrders.title',
    defaultMessage: 'Your recent orders',
  },
  showAll: {
    id: 'containers.CustomerHomePage.components.RecentOrders.showAll',
    defaultMessage: 'Show all',
  },
})
